(function() {
  if (document.querySelectorAll('.js-klantquotes').length > 0) {
    let allKlantQuotes = document.querySelectorAll('.js-klantquotes');
    
    allKlantQuotes.forEach(function(klantQuote) {
      let cards = klantQuote.querySelectorAll('.quo__card'),
          firstCard = cards[0],
          lastCard = cards[-1];

      cards.forEach(function(card, index){
        card.querySelector('.previous-button').addEventListener('click',function(e){
          let prevIndex = index-1;

          e.preventDefault();
          e.stopPropagation();
          card.classList.add('visually-hidden');
          if (index == 0) {
            prevIndex = cards.length-1;
          }
          cards[prevIndex].classList.remove('visually-hidden');
        });

        card.querySelector('.next-button').addEventListener('click',function(e){
          let nextIndex = index+1;

          e.preventDefault();
          e.stopPropagation();
          card.classList.add('visually-hidden');
          if (index == cards.length-1) {
            nextIndex = 0;
          }
          cards[nextIndex].classList.remove('visually-hidden');
        })
      })
    })
  }
})();
